import React from "react";
import { Button, Nav } from "react-bootstrap";
import { FaBars, FaSearch, FaTimes } from 'react-icons/fa';
import { AccountDropdown } from './AccountDropdown';
import gaTracker from '../../util/ga-analytics/gaTracker';
export var SideMenu = function SideMenu(props) {
  var searchActive = props.searchActive,
      mobile = props.mobile,
      handleLogin = props.handleLogin,
      handleShowModal = props.handleShowModal,
      handleAccoount = props.handleAccoount,
      handleShowSidebar = props.handleShowSidebar,
      closeSearch = props.closeSearch,
      displaySearch = props.displaySearch,
      accountInfo = props.accountInfo,
      authenticationState = props.authenticationState,
      isCnbSite = props.isCnbSite,
      isStorePortal = props.isStorePortal,
      _props$cartLength = props.cartLength,
      cartLength = _props$cartLength === void 0 ? 0 : _props$cartLength;

  var hamburgerMenuClick = function hamburgerMenuClick() {
    handleShowSidebar(true);
    var data = {
      gtm: {
        uniqueEventId: '21',
        elementId: "cb-header__hamburger"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var signInClick = function signInClick() {
    handleLogin();
    var data = {
      gtm: {
        uniqueEventId: '7',
        elementId: "cb-header__signin"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var cartClick = function cartClick() {
    var data = {
      gtm: {
        uniqueEventId: '20',
        elementId: mobile ? "banner-cart" : "banner-cart-mobile"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  if (isCnbSite) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
      as: "ul",
      className: "\n        cb-header__navbar-secondary cnb-nav-btn\n        ".concat(searchActive ? 'is-hidden' : '', "\n      ")
    }, /*#__PURE__*/React.createElement(Nav.Item, {
      as: "li"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary cb-button-thin",
      href: '/locations'
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-white"
    }, "Order Now"))))));
  }

  if (isStorePortal) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
      as: "ul",
      className: "\n          cb-header__navbar-secondary cnb-nav-btn\n            ".concat(searchActive ? 'is-hidden' : '', "\n          ")
    }, /*#__PURE__*/React.createElement(Nav.Item, {
      as: "li"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/shop/cart",
      id: mobile ? "banner-cart" : "banner-cart-mobile",
      onClick: cartClick,
      className: "position-relative"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-unstyled cb-button__shop"
    }, "Cart"), Boolean(cartLength) && /*#__PURE__*/React.createElement("span", {
      className: "cb-header__cart-indicator"
    }, cartLength))), /*#__PURE__*/React.createElement(Nav.Item, {
      as: "li"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: hamburgerMenuClick,
      id: "cb-header__hamburger",
      className: "cb-button-unstyled cb-header__button"
    }, /*#__PURE__*/React.createElement(FaBars, {
      className: "fa-3x"
    })))));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    as: "ul",
    className: "\n      cb-header__navbar-secondary\n      ".concat(searchActive ? 'is-hidden' : '', "\n    ")
  }, /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, mobile ? /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-unstyled cb-header__button",
    onClick: displaySearch
  }, /*#__PURE__*/React.createElement(FaSearch, null)) : authenticationState !== 'Authenticated' ? /*#__PURE__*/React.createElement(Button, {
    onClick: signInClick,
    className: "cb-button-unstyled",
    id: "cb-header__signin"
  }, "Sign In") : /*#__PURE__*/React.createElement(AccountDropdown, {
    handleAccoount: handleAccoount,
    authenticationState: authenticationState,
    accountInfo: accountInfo
  }))), /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/cart",
    id: mobile ? "banner-cart" : "banner-cart-mobile",
    onClick: cartClick,
    className: "position-relative"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-unstyled cb-button__shop"
  }, "Cart"), Boolean(cartLength) && /*#__PURE__*/React.createElement("span", {
    className: "cb-header__cart-indicator"
  }, cartLength))), /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: hamburgerMenuClick,
    id: "cb-header__hamburger",
    className: "cb-button-unstyled cb-header__button"
  }, /*#__PURE__*/React.createElement(FaBars, {
    className: "fa-3x"
  })))), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick(e) {
      return closeSearch();
    },
    className: "\n        cb-header__search-close\n        cb-header__button\n        cb-button-unstyled\n        ".concat(!searchActive ? 'is-hidden' : '', "\n        ")
  }, /*#__PURE__*/React.createElement(FaTimes, {
    className: "fa-3x"
  })));
};